import React, {useEffect, useState} from 'react';
import SignInputComponent from 'components/login/SignInputComponent';
import {loginWithEmail, registerWithEmail} from 'util/api';
import NiceButton from 'components/pictures/NiceButton';

const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

const LoginTab = ({onOtpRequested, isRegister}) => {
    const [email, setEmail] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setErrorMessage('');
    }, [isRegister]);

    const handleLogin = async () => {
        if (isSending || !isValidEmail(email)) {
            return;
        }
        try {
            setIsSending(true);
            const otpKeyJson = await (isRegister ? registerWithEmail(email) : loginWithEmail(email));
            const otpKey = otpKeyJson.message;
            onOtpRequested({otpKey, email});
        } catch (error) {
            setIsSending(false);
            if (error.status !== 400) {
                setErrorMessage('Something went wrong. Please try again later or contact us.');
            } else {
                const errorBodyString = await error.body;
                try {
                    const errorBody = JSON.parse(errorBodyString);
                    setErrorMessage(errorBody[0].errorText);
                } catch (parseError) {
                    setErrorMessage('Something went wrong. Please try again later or contact us.');
                }
            }
        }
    };

    const handleInputChange = (field, value) => {
        setEmail(value);
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <SignInputComponent
                inputType="text"
                name="email"
                viewText="Email"
                onEnter={handleLogin}
                onValueChange={(value) => {
                    handleInputChange('username', value);
                    setErrorMessage('');
                }}
                error={errorMessage}
                onKeyPressClearError={() => setErrorMessage('')}
            />

            <div style={{marginTop: '10px', width: '176px'}}>
                <NiceButton
                    onClick={handleLogin}
                    text={isRegister ? "Register" : "Sign In"}
                    disabled={isSending || !isValidEmail(email)}
                />
            </div>
        </div>
    );

};

export default LoginTab;
